import Button from '../forms/Button/Button';
import styles from './BuyCostDisplay.module.css';
import IconEditGoogle from "@/components/icons/IconEditGoogle";

interface BuyCostDisplayProps {
    value?: number | null;
    onClick?: () => void;
    className?: string;
}

export default function BuyCostDisplay({ value = 0, onClick, className = '' }: BuyCostDisplayProps) {
    const formattedPrice = (value && !Number.isNaN(value)) ? `$${Number(value).toFixed(2)}` : '$0.00';

    return (
        <Button
            onClick={onClick}
            className={`${styles.button} ${className}`}
            type="text"
        >
            <span className={styles.price}>{formattedPrice}</span>
            <IconEditGoogle size={14} className={styles.icon} />
        </Button>
    );
}